import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CompareIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const CompareIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.compare', 'Compare');

    return (
      <IconButton
        ref={ref}
        {...props}
        tooltipTitle={tooltipTitle}
      >
        <CompareIcon color="inherit" fontSize={props.size} />
      </IconButton>
    );
  },
);

CompareIconButton.displayName = 'CompareIconButton';
export default CompareIconButton;
